"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorefrontItemsVisibility = void 0;
var StorefrontItemsVisibility;
(function (StorefrontItemsVisibility) {
    StorefrontItemsVisibility["AllItems"] = "ALL_ITEMS";
    StorefrontItemsVisibility["SpecificItems"] = "SPECIFIC_ITEMS";
})(StorefrontItemsVisibility || (exports.StorefrontItemsVisibility = StorefrontItemsVisibility = {}));
//# sourceMappingURL=salesperson.js.map